export const isReactElement = (value) => {
	return (
		value !== null &&
		typeof value === 'object' &&
		'props' in value &&
		'type' in value &&
		(typeof value.type === 'string' || typeof value.type === 'function')
	)
}
